import { Chat } from "@/types";

import { axios } from "../axios.instance";

export type ArchiveChatRequest = {
  chatId: string;
};

export type ArchiveChatResponse = Chat;

export const archiveChat = async (body: ArchiveChatRequest): Promise<ArchiveChatResponse> => {
  const { data } = await axios.post(`/chats/${body.chatId}/archive`);

  return data;
};
